import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-message-dialog',
  templateUrl: './message-dialog.component.html',
  styleUrls: ['./message-dialog.component.less']
})
export class MessageDialogComponent {

	message = this.config.data?.message ?? '';
	
  constructor(private dialogRef: DynamicDialogRef,
							private config: DynamicDialogConfig) { }
	
	closeDialog(): void {
		this.dialogRef.close();
	}

}
